<template>
  <div ref="targetEl">
    <slot v-if="inViewPort"></slot>
  </div>
</template>

<script setup>
import { useIntersectionObserver } from '@vueuse/core';
import { ref } from 'vue';

const targetEl = ref(null);
const inViewPort = ref(false);

const props = defineProps({
  rootMargin: {
    type: Number,
    default: 600,
  },
});

const { stop } = useIntersectionObserver(
  targetEl,
  ([{ isIntersecting }]) => {
    if (isIntersecting) {
      inViewPort.value = isIntersecting;
      stop();
    }
  },
  {
    rootMargin: `${props.rootMargin}px`,
  },
);

defineExpose({ inViewPort });
</script>
